import { PdfPageWrapper } from "../../../forms/pdf-components/PdfPageWrapper";
import { PdfInterventionPatientSections } from "./sections/PdfInterventionPatientSections";
import { PdfPatientAndContactInfo } from "./sections/PdfPatientAndContactInfo";
import { PdfAllergyInformation } from "./sections/PdfAllergyInformation";
import { PdfDetailsSection } from "./sections/PdfDetailsSection";
import { PdfMedicationConditionReview } from "./sections/PdfMedicationConditionReview";

/**
 * PdfPage1
 *
 * Sections:
 *   1. InterventionPatientSections (Name of Service + Prescriber Info)
 *   2. PatientInformation + PatientContactInformation (2-col)
 *   3. AllergyInformation
 *   4. DetailsSection
 *   5. MedicationConditionReview
 */
export const PdfPage1 = ({
  pharmacyProps,
  serviceDate,
  patient,
  clinicalServiceName,
  documentation,
  clinicalAssessment,
  interventionDetails,
  interventionType,
  clinicalServiceTypeCode,
  intervention,
  amrMedicationRow,
  pharmacistFollowUp,
  pharmacistLicenseNumber,
  currentLoggedInUserDetail,
  pharmacyStores,
}) => (
  <PdfPageWrapper pharmacyProps={pharmacyProps}>
    <PdfInterventionPatientSections
      clinicalServiceName={clinicalServiceName}
      documentation={documentation}
      serviceDate={serviceDate}
      pharmacyPhone={pharmacyProps?.pharmacyPhone}
      pharmacyEmail={pharmacyProps?.pharmacyEmail}
      pharmacistLicenseNumber={pharmacistLicenseNumber}
      currentLoggedInUserDetail={currentLoggedInUserDetail}
      pharmacyStores={pharmacyStores}
    />

    <PdfPatientAndContactInfo patient={patient} />

    <PdfAllergyInformation
      patient={patient}
      clinicalAssessment={clinicalAssessment}
    />

    <PdfDetailsSection
      interventionDetails={interventionDetails}
      interventionType={interventionType}
      clinicalServiceName={clinicalServiceName}
      clinicalServiceTypeCode={clinicalServiceTypeCode}
      intervention={intervention}
      amrMedicationRow={amrMedicationRow}
    />

    <PdfMedicationConditionReview pharmacistFollowUp={pharmacistFollowUp} />
  </PdfPageWrapper>
);
